import { z } from 'zod';

/** メンバー種別（アップロード対象。実際に取り込み API へ渡せる具体的な種別のみ） */
const importTypeSearch = z.enum(['EMPLOYEE', 'CONTRACTOR', 'BOARD_MEMBER', 'COLLABORATOR']).catch('EMPLOYEE').default('EMPLOYEE');

/**
 * 一覧タブの種別。具体的なメンバー種別に加え、`ALL`（全種別横断）を許容する。
 * `ALL` の場合は一覧 API の `importType` を未指定で呼び出す。
 */
const importListTabSearch = z.enum(['EMPLOYEE', 'CONTRACTOR', 'BOARD_MEMBER', 'COLLABORATOR', 'ALL']).catch('EMPLOYEE').default('EMPLOYEE');

/** CSV 読み込みリストの検索パラメータ（タブ状態 + ページネーション） */
export const CsvImportListSearchSchema = z.object({
  type: importListTabSearch,
  page: z.number().int().min(1).catch(1).default(1),
  pageSize: z.number().int().min(1).max(2000).catch(100).default(100)
});
/** アップロード画面の検索パラメータ（対象メンバー種別。`ALL` は許容しない） */
export const CsvImportUploadSearchSchema = z.object({
  type: importTypeSearch
});